import React from 'react';
interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}
export function Container({
  children,
  className = ''
}: ContainerProps) {
  return <div className={`mx-auto w-full max-w-content px-5 md:px-8 ${className}`} data-id="element-424" data-mp="1llqgkapvsquf">{children}</div>;
}